module.exports = __webpack_public_path__ + "media/images/menu/puppis-13843378c8d20bc508d4cfc9d8661239.jpg";